import { render, staticRenderFns } from "./ContestFaqFormComponent.vue?vue&type=template&id=a8abe54c"
import script from "./ContestFaqFormComponent.vue?vue&type=script&lang=js"
export * from "./ContestFaqFormComponent.vue?vue&type=script&lang=js"
import style0 from "./ContestFaqFormComponent.vue?vue&type=style&index=0&id=a8abe54c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports